import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: unknown;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error", error, info);
  }

  handleReload = () => window.location.reload();

  render() {
    if (this.state.hasError) {
      return (
        <main className="p-6 max-w-2xl mx-auto space-y-3">
          <h1 className="text-2xl font-semibold">Something went wrong</h1>
          <p className="text-muted-foreground">
            An unexpected error occurred. Try reloading the page.
          </p>
          <button
            className="inline-flex items-center px-4 py-2 rounded-md bg-primary text-primary-foreground"
            onClick={this.handleReload}
          >
            Reload
          </button>
        </main>
      );
    }

    return this.props.children as React.ReactElement;
  }
}
